const React = require('react');
const { Component } = require('react');
const { WelcomeJointHolder } = require('components/jointHolders/welcomeJointHolder');

class Welcome extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <WelcomeJointHolder {...this.props} />;
    }
}

module.exports = Welcome;
